(function() {
  var GUEST_KEY = 'fioboc_zendesk_guest';
  var TOKEN_URL = 'https://tss.jialenet.com/api/v1/zendesk/token';
  var loginPromise = null;
  var loginSucceeded = false;
  var zendeskVisitor = null;

  function createZendeskGuest() {
    var randomPart = Math.floor(1000000000 + Math.random() * 9000000000).toString();
    var timePart = Date.now().toString();
    var guestId = timePart + randomPart;

    return {
      id: guestId,
      name: 'Fioboc User ' + guestId.slice(0, 7),
      email: guestId + '@guest.fioboc.com',
      isLoggedIn: false
    };
  }

  function getStoredZendeskGuest() {
    try {
      var storedGuest = window.localStorage.getItem(GUEST_KEY);
      if (storedGuest) {
        var parsedGuest = JSON.parse(storedGuest);
        if (
          parsedGuest &&
          /^\d+$/.test(String(parsedGuest.id || '')) &&
          parsedGuest.name === 'Fioboc User ' + String(parsedGuest.id).slice(0, 7) &&
          parsedGuest.email === parsedGuest.id + '@guest.fioboc.com'
        ) {
          return parsedGuest;
        }
      }

      var guest = createZendeskGuest();
      window.localStorage.setItem(GUEST_KEY, JSON.stringify(guest));
      return guest;
    } catch (error) {
      return createZendeskGuest();
    }
  }

  function getZendeskVisitor() {
    var customer = (window.__fiobocZendeskCustomer && window.__fiobocZendeskCustomer()) || {};
    if (customer.name && customer.email) {
      return customer;
    }

    return getStoredZendeskGuest();
  }

  function getZendeskJwtFromBackend(visitor) {
    return fetch(TOKEN_URL, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        name: visitor.name,
        email: visitor.email,
        external_id: String(visitor.id || visitor.email)
      })
    }).then(function(response) {
      if (!response.ok) {
        throw new Error('Zendesk token request failed with status ' + response.status);
      }

      return response.json();
    }).then(function(data) {
      if (data && data.code !== undefined && Number(data.code) !== 200) {
        throw new Error(data.message || 'Zendesk token API returned code ' + data.code);
      }
      if (data && data.error !== undefined && Number(data.error) !== 0) {
        throw new Error(data.message || 'Zendesk token API returned error ' + data.error);
      }

      var jwt = data.jwt || (data.data && data.data.jwt);

      if (!jwt) {
        throw new Error('Zendesk token response does not include jwt/token');
      }

      return jwt;
    });
  }

  function loginZendeskUser(visitor, callback) {
    zE('messenger', 'loginUser', function(jwtCallback) {
      getZendeskJwtFromBackend(visitor).then(function(jwt) {
        jwtCallback(jwt);
      }).catch(function(error) {
        console.warn('[Zendesk] failed to fetch JWT from backend', error);
        jwtCallback('');
      });
    }, function(error) {
      if (error) {
        console.warn('[Zendesk] loginUser failed', error);
      }

      if (typeof callback === 'function') {
        callback(!error, error);
      }
    });
  }

  function prepareZendeskVisitor(callback) {
    if (loginSucceeded) {
      if (typeof callback === 'function') {
        callback(zendeskVisitor, true);
      }
      return;
    }

    if (!loginPromise) {
      zendeskVisitor = getZendeskVisitor();
      loginPromise = new Promise(function(resolve) {
        loginZendeskUser(zendeskVisitor, function(succeeded, error) {
          loginSucceeded = succeeded;
          resolve({
            visitor: zendeskVisitor,
            loginSucceeded: succeeded,
            loginError: error
          });
        });
      });
    }

    loginPromise.then(function(result) {
      if (typeof callback === 'function') {
        callback(result.visitor, result.loginSucceeded, result.loginError);
      }
    });
  }

  function waitForZendesk(callback) {
    var timer = setInterval(function() {
      if (window.zE) {
        clearInterval(timer);
        callback();
      }
    }, 100);
  }

  waitForZendesk(function() {
    zE('messenger', 'close');
    prepareZendeskVisitor();

    var zendeskButton = document.querySelector('.zendesk-button');
    if (zendeskButton) {
      zendeskButton.addEventListener('click', function() {
        console.log('click11')
        prepareZendeskVisitor(function() {
          zE('messenger', 'open');
        });
      });
    }
  });
})();
